import url from '../url'
import headers from '../headers'

export default {
	get (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/organization/`,
			headers.bearer()
		)
	},
	add (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/organization/`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/organization/`,
			model,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/organizations.js